import React from "react";
export default class News extends React.Component {
     render(){
         return <div>Mine</div>
     }
}